<template>
  <v-layout class="hv-100">
    <AppBar v-if="showAppBar" />
    
    

    <v-main class="h-100">
      <router-view class="pa-2" />
      <v-overlay absolute class="align-center justify-center" :model-value="surveyResponseStore.fetchingSurveyInfo">
        <v-progress-circular color="primary" indeterminate size="32"/>
      </v-overlay>
    </v-main>
  </v-layout>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router';
import AppBar from './components/general/AppBar.vue';
import { useSurveyResponseStore } from './stores/SurveyResponseStore';
import { computed, watch } from 'vue';
import { onMounted } from 'vue';

const router = useRouter();
const surveyResponseStore = useSurveyResponseStore();

function refreshFolioInStore() {
  const id = router.currentRoute.value.params.id as string;
  if (!id) {
    surveyResponseStore.setId(null);
    return;
  }
  
  if (id === String(surveyResponseStore.id))
    return;

  if (id === 'new')
    surveyResponseStore.setId(id);
  else
    surveyResponseStore.setId(Number(id));
}

const showAppBar = computed(() => {
  return router.currentRoute.value.name !== 'login';
})

watch(router.currentRoute, () => {
  refreshFolioInStore();
}, { deep: true })

onMounted(() => {
  refreshFolioInStore();
})

</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.hv-100 {
  height: 100vh;
}

.v-list-group {
  --prepend-width: 8px !important;
}

.v-list-item__spacer {
  width: 16px !important;
}

</style>
